import { FunctionComponent } from 'react';
import { Text } from 'evergreen-ui';
import styles from '../styles.module.css';

type FeedbackProps = {
    feedbackCorrect?: string;
    feedbackWrong?: string;
};

export const Feedback: FunctionComponent<FeedbackProps> = ({ feedbackCorrect, feedbackWrong }) => {
    if (!feedbackCorrect && !feedbackWrong) return null;

    return (
        <div className={feedbackCorrect ? styles.feedback_correct : styles.feedback_wrong}>
            <Text>{feedbackCorrect || feedbackWrong}</Text>
        </div>
    );
};
